import Location from "../../../hooks/Location"
import HouseholdDataTable from './HouseholdDataTable'
import HouseholdFixedDataCard from './HouseholdFixedDataCard'
import ExternalDataCard from './ExternalDataCard'
import SelfPickupCard from './SelfPickupCard'
import HouseholdLocationCard from './HouseholdLocationCard'
import HouseholdSmsConsentCard from './HouseholdSmsConsentCard'
import HouseholdQualifyingCard from './HouseholdQualifyingCard'

/**
 * Tabblad 'Gegevens' op de huishoudenpagina: de kaart 'Vaste gegevens' en
 * 'Kwalificering' (alleen lezen), daaronder
 * de eigen gegevens van de organisatie, plus de kaart met externe data. De tabel zelf zit in `HouseholdDataTable`, zodat de afspraak
 * dezelfde tabel toont in plaats van een kopie.
 *
 * `showSelfPickup` staat standaard UIT. Dit tabblad wordt ook op de mobiele
 * huishoudenpagina gebruikt, en daar hoort het vrijgeven niet thuis: dat is een
 * beslissing van de planner. Een klusser corrigeert op zijn telefoon hoogstens
 * een huishouden dat hij zelf heeft opgepakt, en daar is een eigen knop voor.
 * Een standaard die dicht valt, zodat een nieuwe afnemer hem niet per ongeluk
 * erft. AI-CONTEXT: See docs/features/huishouden-zelf-op-te-pakken.md
 *
 * @param {object} props
 * @param {string} props.adressNavigation - Het actieve tabblad op de huishoudenpagina
 * @param {boolean} [props.showSelfPickup] - Of de sectie 'Zelf op te pakken' meekomt
 */
const Data = ({ adressNavigation, showSelfPickup = false }) => {
  // Hooks
  const adressId = Location()[3]

  return (
    <div style={{display: adressNavigation === 'data' ? 'block' : 'none'}}>
      <div className="adress-data-layout">
        <div className="adress-data-layout-main">
          <HouseholdFixedDataCard adressID={adressId} />
          {adressNavigation === 'data' && <HouseholdQualifyingCard adressID={adressId} />}
          <h3 className="adress-own-data-title">Eigen gegevens</h3>
          <HouseholdDataTable adressID={adressId} />
          {adressNavigation === 'data' && <HouseholdLocationCard />}
          {adressNavigation === 'data' && <HouseholdSmsConsentCard />}
          {showSelfPickup && adressNavigation === 'data' && <SelfPickupCard />}
        </div>
        {adressNavigation === 'data' && (
          <div className="adress-data-layout-side">
            <ExternalDataCard />
          </div>
        )}
      </div>
    </div>
  )
}

export default Data
